module.exports = __webpack_public_path__ + "img/Sir-Imtiaz.0be056a9.jpg";